import SpinnerIcon from '@viking-eng/icon/lib/Spinner';
import PropTypes from '@viking-eng/prop-types';
import React from 'react';
import './Spinner.css';

const colors = ['black', 'white', 'blue', 'red'];

const Spinner = ({ color, dataId, spinnerClassName }) => {
  if (!colors.includes(color)) {
    throw new Error(`Supplied color, "${color}", is not supported. Must be one of: ${colors.join(', ').toString()}.`);
  }
  return (
    <div data-id={dataId} className={`spinner-container ${color} ${spinnerClassName}`} aria-label="loading">
      <SpinnerIcon />
    </div>
  );
};

Spinner.defaultProps = {
  color: 'black',
  dataId: undefined,
  spinnerClassName: ''
};

Spinner.propTypes = {
  color: PropTypes.oneOf(colors),
  dataId: PropTypes.string,
  spinnerClassName: PropTypes.string
};

export default Spinner;
